"use client";

import { useContext } from "react";
import { ModalContext } from "../hooks/useModal";
import ConfirmAction from "./ConfirmAction";
import Dialog from "./Dialog";

// "Unsaved changes" confirm, stacked above the main modal. Rendering it as a
// separate dialog (instead of swapping the main modal's children) keeps the
// flow underneath mounted, so cancelling preserves its in-progress state.
//
// `ConfirmAction` is imported statically on purpose: a lazy import paints the
// dialog one frame before its content resolves (React.lazy always suspends on
// first mount, even with the chunk cached), flashing an empty white card. The
// component only pulls Button/Spinner/Typography — already in the providers'
// graph — so eager loading costs almost nothing.
const ModalConfirmDialog = () => {
  const modal = useContext(ModalContext);

  return (
    <Dialog
      isOpen={Boolean(modal.pendingConfirm)}
      onClose={modal.cancelPendingClose}
      // The main modal's overlay sits at z-[9999]; force this one above it.
      overlayClassName="!z-[10000]"
      className="max-w-md"
    >
      {modal.pendingConfirm ? (
        <ConfirmAction
          title="Unsaved changes"
          description="Unsaved changes will be lost. Are you sure you want to close?"
          onConfirm={modal.confirmPendingClose}
          onCancel={modal.cancelPendingClose}
        />
      ) : null}
    </Dialog>
  );
};

export default ModalConfirmDialog;
